import React from 'react';
import { isSSR } from '../Utils/ssrUtils.js';

function isInEditor(contentBlock) {
  return contentBlock.toJS;
}
function getTextAlignment(contentBlock) {
  var _a;
  return isInEditor(contentBlock) ? contentBlock.getData().get("textAlignment") : (_a = contentBlock == null ? void 0 : contentBlock.data) == null ? void 0 : _a.textAlignment;
}
function getEntityAt(i, block) {
  var _a;
  return isInEditor(block) ? block.getEntityAt(i) : (_a = block.entityRanges.find(({ offset, length }) => i >= offset && i < offset + length)) == null ? void 0 : _a.key;
}
function getEntityType(block, contentState, entityKey) {
  var _a;
  return isInEditor(block) ? entityKey !== null && contentState.getEntity(entityKey).getType() : (_a = contentState.entityMap[entityKey]) == null ? void 0 : _a.type;
}
function isLinkType(type) {
  return type === "LINK" || type === "ricos-plugin-custom-link";
}
function isInLink(i, block, contentState) {
  const entityKey = getEntityAt(i, block);
  const type = getEntityType(block, contentState, entityKey);
  return isLinkType(type);
}
function isChrome() {
  return !isSSR() && !!window.chrome;
}
function createJustificationFixDecorator() {
  const isTextJustified = (contentBlock) => getTextAlignment(contentBlock) === "justify";
  const strategy = (contentBlock, callback, contentState) => {
    if (!isSSR() && !isChrome() && isTextJustified(contentBlock)) {
      const regex = /\s[^\s]/g;
      const str = contentBlock.getText();
      let match;
      while ((match = regex.exec(str)) !== null) {
        if (!isInLink(match.index, contentBlock, contentState)) {
          callback(match.index, match.index + 1);
        }
      }
    }
  };
  const component = (props) => /* @__PURE__ */ React.createElement("span", { style: { whiteSpace: "normal" } }, props.children);
  return { strategy, component };
}

export { createJustificationFixDecorator as default };
//# sourceMappingURL=createJustificationFixDecorator.js.map
